/* Homepage-only interactivity: hovering a BOLD/ISHARA row swaps the line's
   big image to that product's photo. The "Select options" / Seen in Signals
   quick-view popup itself lives in the shared editorial-quickview.js. */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-editorial-root]');
    if (!root) return;

    root.querySelectorAll('.ed-line').forEach(function (line) {
      var mediaImg = line.querySelector('[data-ed-line-image]');
      if (!mediaImg) return;
      var originalSrc = mediaImg.getAttribute('src');
      line.querySelectorAll('[data-ed-hover-image]').forEach(function (row) {
        row.addEventListener('mouseenter', function () {
          var src = row.getAttribute('data-ed-hover-image');
          if (src) mediaImg.src = src;
        });
        row.addEventListener('mouseleave', function () {
          mediaImg.src = originalSrc;
        });
      });
    });
  });
})();
